/**
 * Formats an ISO date string (YYYY-MM-DD) into MM/DD/YY format.
 * e.g. "2026-02-06" → "02/06/26"
 */
export function formatAssessmentDate(
  dateStr: string | null | undefined
): string {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  const year = parts[0] ?? '';
  const month = parts[1] ?? '';
  const day = parts[2] ?? '';
  return `${month}/${day}/${year.slice(2)}`;
}
